'use client'
import { format } from 'date-fns'
import { useTranslations } from 'next-intl'
import React, { ReactNode } from 'react'
import 'react-day-picker/lib/style.css'
import HelperButton from '../HelperButton'
import { Label } from '../Label'
import { IHelperButton } from '../types'
import styles from './styles.module.scss'

export const DATE_PICKER_FORMAT = 'yyyy-MM-dd'

interface DatePickerInputProps {
  label?: string
  placeholder?: string
  value?: Date | undefined
  onClick: (e: any) => void
  onResetClick?: () => void
  isDisabled?: boolean
  helperButton?: IHelperButton
  tooltip?: string | ReactNode
  mode?: 'light' | 'dark'
  errorWhenEmpty?: boolean
}

const DatePickerInput: React.FC<DatePickerInputProps> = ({
  label,
  placeholder,
  value,
  onClick,
  onResetClick,
  isDisabled,
  helperButton,
  tooltip,
  mode,
  errorWhenEmpty = false,
}) => {
  const t = useTranslations('translation')
  const onReset = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    onResetClick && onResetClick()
  }

  return (
    <div
      className={`${styles.inputWrapper} ${
        label ? styles.inputWrapperWithLabel : ''
      }`}
    >
      {label && <Label>{label}</Label>}
      <div
        className={`${styles.dateInput} ${mode ? styles?.[mode] || '' : ''} ${
          !value ? styles.empty : ''
        } ${isDisabled ? styles.disabled : ''} ${
          helperButton?.type === 'error'
            ? styles.error
            : errorWhenEmpty && !value
            ? styles.error
            : ''
        }`}
        onClick={e => {
          if (!isDisabled) onClick(e)
        }}
      >
        {value
          ? format(new Date(value), DATE_PICKER_FORMAT)
          : placeholder || t('dateFormat')}

        {!isDisabled && onResetClick && value && (
          <button className={styles.resetButton} onClick={onReset} />
        )}
        {helperButton && <HelperButton {...helperButton} tooltip={tooltip} />}
      </div>
    </div>
  )
}
export default DatePickerInput
